import { IRect } from "../../interfaces/IRect";
import { ProjectService } from "../../services/project.service";
import { FrameProfile } from "../profiles/frame.model";
import { Orientation } from "../ToolboxModel";
import { ElementStoreModel } from "./element-store.model";

export class FrameStoreModel extends ElementStoreModel {
	rect: IRect;
	orientation: Orientation;
	length: number;

	constructor(f: FrameProfile, cid: string) {
		if (f) {
			if (!f.configId) {
				f.configId = cid;
			}
			super(f.id, f.configId, f.tag, f.cuttingOnSite, f.inOffer);

			this.rect = f.rect;
			this.orientation = f.orientation;
			this.length = f.getLength();

		} else {
			super("", "", "", false, false);
		}
	}

	public static restore(f: FrameStoreModel, projectService: ProjectService, defConfigId: string = null) {
		var extra = projectService.template.hiddenExtras.find(profile => profile.id == f.configId);
		if (!extra && defConfigId != null) {
			var extra = projectService.template.hiddenExtras.find(profile => profile.id == defConfigId);
		}
		var newFrame = new FrameProfile(f.rect.x, f.rect.y, f.length, extra.size, extra.color, f.orientation, f.configId);
		newFrame.rect = f.rect;
		newFrame.inOffer = f.inOffer ?? true;
		return newFrame; 
	}
}
